import { useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { Col, Row } from "react-bootstrap";

import { setUserDetails, toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { change2FA } from "../../../service";
import { Switch } from "components/Switch";
import { ChangePhone } from "../../Components/ChangePhone";
import { userDetailSelect } from "Layout/slice/selector";
import { Heading } from "style/components/Heading.styles";
import { TwoFactorAuthenticationContainer } from "./TwoFactorAuthentication.styles";

export const TwoFactorAuthentication = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const profileDetails = useSelector(userDetailSelect);

  const [enable, setEnable] = useState(false);
  const twoFactorEnabled = Boolean(profileDetails?.two_factor_auth_enabled);

  // Organization-level switch for MFA as a whole; `two_factor_auth_enabled` is
  // only the user's own preference within it.
  const allowed = Boolean(profileDetails?.mfa_allowed);

  const handleSwitchChange = async (value) => {
    if (profileDetails?.phone_verified) {
      handleChange2FA(value);
    } else {
      setEnable(value);
    }
  };

  const handleChange2FA = async (value) => {
    try {
      const response = await change2FA({
        value: value ? "ON" : "OFF",
      });
      // The switch renders from this, so Redux has to carry the new value or
      // a successful toggle would snap straight back to its old position.
      dispatch(
        setUserDetails({
          ...userDetailSelect(store.getState()),
          two_factor_auth_enabled: response?.two_factor_auth_enabled ?? value,
        })
      );
      dispatch(
        toast({
          body: `2FA has been ${value ? "enabled" : "disabled"} successfully!`,
        })
      );
    } catch (error) {
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };

  const handleVerifiedCode = () => {
    setEnable(false);
    handleChange2FA(true);
  };

  // Placed after every hook so the hook order stays stable when the flag
  // arrives with the profile.
  if (!allowed) return null;

  return (
    <TwoFactorAuthenticationContainer>
      <div className="switch-wrapper">
        <div className="heading-wrapper">
          <Heading>Two-factor authentication (2FA)</Heading>
          <span>Keep your account secure by enabling 2FA via SMS</span>
        </div>
        <div className="text-message-wrapper">
          <Switch
            variant="secondary"
            size="small"
            onChange={handleSwitchChange}
            value={twoFactorEnabled}
          />
          <div className="text-message-inner-wrapper">
            <p className="mb-0">Text Message (SMS)</p>
            <span>
              Receive a one-time passcode via SMS each time you log in.
            </span>
          </div>
        </div>
      </div>

      {enable && (
        <Row className="mb-4">
          <Col md={4}>
            <ChangePhone onSuccess={handleVerifiedCode} />
          </Col>
        </Row>
      )}

      <div className="divider mt-1 mb-3"></div>
    </TwoFactorAuthenticationContainer>
  );
};
